import React from "react";
var cellRenderer = function (row, colKey) {
    var _a, _b;
    var value = (_a = row[colKey]) !== null && _a !== void 0 ? _a : "";
    if ((_b = row.duplicateVariables) === null || _b === void 0 ? void 0 : _b.includes(colKey)) {
        return React.createElement("span", { style: { color: "red" } }, value);
    }
    return value;
};
/**
 * Builds the column definitions for the potential-duplicates table.
 *
 * Both the identification column (companyNumber/taxNumber) and the name column
 * are clickable and open the duplicate detail side panel via `onDuplicateClick`
 * (DB-192): the customer needs to reach duplicates matched purely by name, not
 * only those matched by identification number.
 *
 * @param formatMessage react-intl message formatter
 * @param onDuplicateClick invoked with the duplicate publisher id on cell click
 * @return column definitions for {@link TableComponent}
 */
export var buildDuplicateColumns = function (formatMessage, onDuplicateClick) { return [
    {
        name: formatMessage({
            id: "ui-br-publishers.duplicatesTable.columns.companyNumberOrTaxNumberOrBirthDate",
        }),
        key: "companyNumberOrTaxNumberOrBirthDate",
        onClick: function (row) { var _a; return onDuplicateClick === null || onDuplicateClick === void 0 ? void 0 : onDuplicateClick((_a = row.id) !== null && _a !== void 0 ? _a : ""); },
        clickable: true,
        cellRenderer: function (row) {
            return cellRenderer(row, "companyNumberOrTaxNumberOrBirthDate");
        },
    },
    {
        name: formatMessage({
            id: "ui-br-publishers.duplicatesTable.columns.name",
        }),
        key: "name",
        onClick: function (row) { var _a; return onDuplicateClick === null || onDuplicateClick === void 0 ? void 0 : onDuplicateClick((_a = row.id) !== null && _a !== void 0 ? _a : ""); },
        clickable: true,
        cellRenderer: function (row) { return cellRenderer(row, "name"); },
    },
    {
        name: formatMessage({
            id: "ui-br-publishers.duplicatesTable.columns.nameSuffix",
        }),
        key: "nameSuffix",
        cellRenderer: function (row) { return cellRenderer(row, "nameSuffix"); },
    },
    {
        name: formatMessage({
            id: "ui-br-publishers.duplicatesTable.columns.qualifier",
        }),
        key: "qualifier",
        cellRenderer: function (row) { return cellRenderer(row, "qualifier"); },
    },
    {
        name: formatMessage({
            id: "ui-br-publishers.duplicatesTable.columns.phone",
        }),
        key: "phone",
        cellRenderer: function (row) { return cellRenderer(row, "phone"); },
    },
    {
        name: formatMessage({
            id: "ui-br-publishers.duplicatesTable.columns.email",
        }),
        key: "email",
        cellRenderer: function (row) { return cellRenderer(row, "email"); },
    },
    {
        name: formatMessage({
            id: "ui-br-publishers.duplicatesTable.columns.municipality",
        }),
        key: "municipality",
        cellRenderer: function (row) { return cellRenderer(row, "municipality"); },
    },
    {
        name: formatMessage({
            id: "ui-br-publishers.duplicatesTable.columns.street",
        }),
        key: "street",
        cellRenderer: function (row) { return cellRenderer(row, "street"); },
    },
]; };
